// extracted by mini-css-extract-plugin
module.exports = {"shortDescriptionRoot":"R3AQ4pLa","heading":"RsLQfvUZ","text":"MbKRrVct"};